import React from "react";
import styles from "./styles.module.scss";
import { classNames } from "src/shared/lib/classNames/classNames";

const Divider = ({ className }) => {
	return <div className={classNames(styles.divider, {}, [className])} />;
};

export default Divider;
